import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import AsyncStorage from '@react-native-async-storage/async-storage';

// Import locale files
import commonEn from './locales/en/common.json';
import loginEn from './locales/en/login.json';
import drawerEn from './locales/en/drawer.json';
import housekeepingEn from './locales/en/housekeeping.json';
import settingsEn from './locales/en/settings.json';

import commonTa from './locales/ta/common.json';
import loginTa from './locales/ta/login.json';
import drawerTa from './locales/ta/drawer.json';
import housekeepingTa from './locales/ta/housekeeping.json';
import settingsTa from './locales/ta/settings.json';

import commonMl from './locales/ml/common.json';
import loginMl from './locales/ml/login.json';
import drawerMl from './locales/ml/drawer.json';
import housekeepingMl from './locales/ml/housekeeping.json';
import settingsMl from './locales/ml/settings.json';
import commonHi from './locales/hi/common.json';
import loginHi from './locales/hi/login.json';
import drawerHi from './locales/hi/drawer.json';
import housekeepingHi from './locales/hi/housekeeping.json';
import settingsHi from './locales/hi/settings.json';
import commonKn from './locales/kn/common.json';
import loginKn from './locales/kn/login.json';
import drawerKn from './locales/kn/drawer.json';
import housekeepingKn from './locales/kn/housekeeping.json';
import settingsKn from './locales/kn/settings.json';
import commonTe from './locales/te/common.json';
import loginTe from './locales/te/login.json';
import drawerTe from './locales/te/drawer.json';
import housekeepingTe from './locales/te/housekeeping.json';
import settingsTe from './locales/te/settings.json';
import uiEn from './locales/en/ui.json';
import uiTa from './locales/ta/ui.json';
import uiMl from './locales/ml/ui.json';
import uiHi from './locales/hi/ui.json';
import uiKn from './locales/kn/ui.json';
import uiTe from './locales/te/ui.json';

const resources = {
  en: {
    common: commonEn,
    login: loginEn,
    drawer: drawerEn,
    housekeeping: housekeepingEn,
    settings: settingsEn,
    ui: uiEn
  },
  ta: {
    common: commonTa,
    login: loginTa,
    drawer: drawerTa,
    housekeeping: housekeepingTa,
    settings: settingsTa,
    ui: uiTa
  },
  ml: {
    common: commonMl,
    login: loginMl,
    drawer: drawerMl,
    housekeeping: housekeepingMl,
    settings: settingsMl,
    ui: uiMl
  },
  hi: {
    common: commonHi,
    login: loginHi,
    drawer: drawerHi,
    housekeeping: housekeepingHi,
    settings: settingsHi,
    ui: uiHi
  },
  kn: {
    common: commonKn,
    login: loginKn,
    drawer: drawerKn,
    housekeeping: housekeepingKn,
    settings: settingsKn,
    ui: uiKn
  },
  te: {
    common: commonTe,
    login: loginTe,
    drawer: drawerTe,
    housekeeping: housekeepingTe,
    settings: settingsTe,
    ui: uiTe
  }
};

export const initI18n = async () => {
  try {
    const savedLang = await AsyncStorage.getItem('appLanguage');
    const lng = savedLang || 'en';

    await i18n.use(initReactI18next).init({
      resources,
      lng,
      fallbackLng: 'en',
      defaultNS: 'common',
      ns: ['common', 'login', 'drawer', 'housekeeping', 'settings', 'ui'],
      interpolation: {
        escapeValue: false
      }
    });
  } catch (error) {
    console.error('Failed to initialize i18n:', error);
    // Fallback to English if AsyncStorage fails
    i18n.use(initReactI18next).init({
      resources,
      lng: 'en',
      fallbackLng: 'en',
      defaultNS: 'common',
      ns: ['common', 'login', 'drawer', 'housekeeping', 'settings', 'ui'],
      interpolation: {
        escapeValue: false
      }
    });
  }
};

export const changeLanguage = async (lang: string) => {
  try {
    await AsyncStorage.setItem('appLanguage', lang);
    await i18n.changeLanguage(lang);
  } catch (error) {
    console.error('Failed to change language:', error);
    await i18n.changeLanguage(lang);
  }
};

export default i18n;
